import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { actionCreators } from "./redux/activeClientsSagas";
import ProspectTypes from "./smartComponents/ProspectTypes";
import MembershipTypes from "./smartComponents/MembershipTypes";
import FilterBy from "./smartComponents/FilterBy";
import LoadingAnimation from "../../../components/loadingAnimation/loadingAnimation";
import SectionToggle from "../../../components/sectionToggle/sectionToggle";
import CrossRegionalVisits from "./smartComponents/crossRegionalVisits";
import KBLearnMore from "../../../components/learnMore/KBLearnMore";
import { ILEARN_URLS } from "../../../constants/ilearnUrls";
import CustomDateRanges from "./smartComponents/customDateRanges";
import TableChart from "./smartComponents/tableChart";
import PeriodType from "./smartComponents/periodType";
import DatePicker from "./smartComponents/datePicker";
import LineChart from "./smartComponents/lineChart";
import { UpdateBtns } from "./smartComponents/UpdateBtns";
import { MEMBERSHIP_TYPES } from "./constants";
import "../attendance_common.css.scss";

const ActiveClientsModule = (props) => {
  const dispatch = useDispatch();
  const sourceType = useSelector((state) => state.commonReducer.commonProps.sourceType);
  const toggles = useSelector((state) => state.activeClients.filters.toggles);
  const initialRequest = useSelector((state) => state.activeClients.initialRequest);
  const updatesLoading = useSelector((state) => state.activeClients.updatesLoading);
  const isLoading = useSelector((state) => state.activeClients.isLoading);
  const isCrossRegionalVisitsIncluded = useSelector(
    (state) => state.activeClients.filters.toggles.crossRegionalVisits.default
  );
  const filterBy = useSelector((state) => state.activeClients.selectedFilters.filter_by);
  useEffect(() => {
    !initialRequest && dispatch(actionCreators.fetchCurrentUser(props));
  }, []);

  const content = () => (
    <div>
      <div id="override-edit-selection-bar" className="edit-selections-bar">
        <div className="top-filter">
          <div className="top-filter__left">
            <FilterBy />

            {filterBy === MEMBERSHIP_TYPES ? <MembershipTypes /> : <ProspectTypes />}
            {sourceType === "clubready" && isCrossRegionalVisitsIncluded && (
              <div className="select-box-no-width">
                <p>{toggles.crossRegionalVisits.label}</p>
                <CrossRegionalVisits />
              </div>
            )}
          </div>

          <div className="top-filter__right">
            <div className="select-box-no-width">
              <p>Period Type</p>
              <PeriodType />
            </div>

            <div className="select-box-no-width date-range-select-box">
              <p>Date Range</p>
              <CustomDateRanges />
            </div>

            <div className="date-select-box select-box-no-width multi">
              <p>Date</p>
              <DatePicker />
            </div>

            <UpdateBtns />
          </div>
        </div>
      </div>
      <div className="chart-root">
        {updatesLoading ? <LoadingAnimation text="Updating data..." /> : <LineChart />}
      </div>
      <div className="chart-root">
        {updatesLoading ? <LoadingAnimation text="Updating data..." /> : <TableChart />}
      </div>
    </div>
  );

  return (
    <div id="attendance-root">
      <SectionToggle
        autoHeight
        height={690}
        title={`Active ${props.clientName}`}
        isLoading={isLoading}
        content={content()}
        learnMore={<KBLearnMore {...learnMoreProps(props.clientName)} />}
      />
    </div>
  );
};

const learnMoreProps = (clientName) => {
  const name = clientName?.toLowerCase();
  const singular = name?.replace(/s$/, "");

  return {
    title: `Active ${clientName}`,
    description: `This report shows ${name} who are actively visiting within the selected date range, distinguishing between new and returning ${name} based on system criteria. These insights help you understand engagement levels, monitor ${singular} activity, and identify shifts in participation.`,
    kbUrl: ILEARN_URLS.attendance.activeClients,
    customStyles: { width: "500px" }
  };
};

export default React.memo(ActiveClientsModule);
